module.exports = __webpack_public_path__ + "img/coupon-icon-02.d0d0f6ad.png";